/**
 * LooksLab — Checkout & Invoice Configuration
 *
 * Edit every field here. These values appear on invoices, confirmation pages,
 * and in the Discord flow instructions.
 */

export const checkoutConfig = {
  // ── Company info (appears on invoice header) ──────────────────
  company: {
    name: 'LooksLab',
    tagline: 'Research-Grade Peptides',
    email: 'support@lookslab.shop',
    website: 'https://lookslab.shop',
    // address: '123 Research Blvd, Suite 100, City, State 00000',  // optional
  },

  // ── Invoice settings ─────────────────────────────────────────
  invoice: {
    prefix: 'LL',           // invoice numbers will be LL-YYYYMM-XXXXX
    currency: 'USD',
    currencySymbol: '$',
    dueDays: 3,             // payment due X days after invoice date
    notes:
      'All products are sold for in-vitro research purposes only. ' +
      'Not for human use. Not FDA approved.',
    thankYouMessage:
      'Thank you for your order. Please follow the payment instructions below and submit proof via Discord.',
  },

  // ── Payment methods (shown on invoice + confirmation page) ────
  // Add as many as you need. Each will render as a section on the invoice.
  paymentMethods: [
    {
      id: 'crypto-btc',
      label: 'Bitcoin (BTC)',
      instructions: 'Send exact amount to wallet address below. Include your invoice number in the transaction memo if possible.',
      details: 'BTC Address: [YOUR_BTC_ADDRESS]',   // ← update
    },
    {
      id: 'crypto-eth',
      label: 'Ethereum (ETH)',
      instructions: 'Send exact amount to wallet address below.',
      details: 'ETH Address: [YOUR_ETH_ADDRESS]',   // ← update
    },
    {
      id: 'crypto-usdc',
      label: 'USDC (ERC-20)',
      instructions: 'Send exact USDC amount on the Ethereum network.',
      details: 'USDC Address: [YOUR_USDC_ADDRESS]', // ← update
    },
    {
      id: 'zelle',
      label: 'Zelle',
      instructions: 'Send to the email/phone below. Put your invoice number in the memo.',
      details: 'Zelle: [YOUR_ZELLE_EMAIL_OR_PHONE]', // ← update
    },
  ],

  // ── Discord flow ──────────────────────────────────────────────
  discord: {
    inviteUrl: 'https://discord.gg/YOURINVITE',   // ← update with real invite
    serverName: 'LooksLab',
    ownerName: 'Alexandar Francois',              // ← used in the safety notice on invoices
    communityIntroText:
      'LooksLab Discord is where our community lives. Join for free customer support, real-time order updates, and direct access to the team. ' +
      'Whether you have a question about your order or just want to stay in the loop — this is the place to be.',
    steps: [
      'Get free support directly from our team in real time.',
      'Ask questions about your order, products, or shipping.',
      'Stay up to date on new drops, restocks, and exclusive offers.',
      'Our owner may reach out through the server to help with your order.',
    ],
  },

  // ── Order Insurance (optional add-on at checkout) ─────────────
  insurance: {
    enabled: false,                          // set to true to show the option
    label: 'Order Insurance',
    price: 9.99,
    description:
      'Protect your order against loss or seizure. ' +
      'If your package doesn\'t arrive for any reason, we\'ll reship your items at no additional cost to you.',
  },

  // ── Shipping ─────────────────────────────────────────────────
  shipping: {
    freeThreshold: 100,       // free shipping on orders over this amount
    standardRate: 9.99,
    standardLabel: 'Standard shipping',
    expeditedRate: 24.99,
    expeditedLabel: 'Expedited shipping',
  },

  // ── Pre-order shipping ────────────────────────────────────────
  // Fee added when customer chooses to ship in-stock and pre-order items separately.
  preorderShipping: {
    separateFee: 9.99,
    separateLabel: 'Pre-order second shipment',
    separateDescription: 'Covers a second shipment when your pre-order items are ready to ship.',
  },
}

